<div class="generic-confirm-modal">
  <div class="generic-confirm-modal__header acknowledgement-header">
    <h3 class="modal-title" data-testid="acknowledgement-title">One last step</h3>
  </div>
  <div class="generic-confirm-modal__body">
    <p data-testid="acknowledgement-message">
      Please confirm that you've reviewed all signed documents.
    </p>
  </div>
  <div class="generic-confirm-modal__footer">
    <app-button
      type="primary"
      [dataTestId]="'acknowledgement-confirm'"
      (buttonClick)="acknowledgeClick()"
    >
      Acknowledge and submit
    </app-button>
  </div>
</div>
